import moment from 'moment'
import { convertToBRL } from '~/utils/formatters'
import { isPaymentRequired } from '~/helpers/isPaymentRequired'

export const getWhatsappFileMessage = (file) => {
  var message = '%0a%0aDescrição: ' + file.description;
  message += '%0aApuração / Data de competência: ' + moment(file.competency_at).format("MM/YYYY");

  if (isPaymentRequired(file.requires_payment)) {
    message += '%0aVencimento: ' + moment(file.due_at).format("DD/MM/YYYY");
    message += '%0aValor: ' + convertToBRL(file.amount);
  }

  message += '%0aLink: ' + file.access_url;

  return message;
}
// Texto do aviso das guias ao cliente (quebras de linha como %0a, pronto
// para a URL do WhatsApp). Usado no envio por WhatsApp e no "Copiar aviso"
// da Conferência, para os dois mostrarem o mesmo texto.
export const getWhatsappMessage = (customerName, files) => {
  if (files.length === 1) {
    return `Prezado cliente, ${customerName}.%0aEncontra-se disponível a obrigação ${
      files[0].description
    } com os seguintes dados:${getWhatsappFileMessage(files[0])}`;
  }

  return `Prezado cliente, ${customerName}.%0aEncontram-se disponíveis obrigações com os seguintes dados: ${files
    .map((file) => getWhatsappFileMessage(file))
    .join('')}`;
}
